// src/components/Issues/IssueActionsMenu.js
import React from 'react';
import {
  Menu,
  MenuItem,
} from '@mui/material';
import Can from '../permissions/Can';

const IssueActionsMenu = ({
  anchorEl,
  selectedIssue,
  onClose,
  onViewIssue,
  onEditIssue,
  onOpenStatusDialog,
  onOpenAssignDialog,
  onOpenAssignedUsersDialog,
  onDeleteIssue,
}) => {
  const handleView = () => {
    onViewIssue(selectedIssue.id);
    onClose();
  };

  const handleDelete = () => {
    onDeleteIssue(selectedIssue);
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
    >
      <Can permission="issue-view">
        <MenuItem onClick={handleView}>View</MenuItem>
      </Can>
      {/* <Can permission="issue-edit">
        <MenuItem onClick={handleEdit}>Edit</MenuItem>
      </Can> */}
      <Can permission="issue-status">
        <MenuItem onClick={onOpenStatusDialog}>Update Status</MenuItem>
      </Can>
      <Can permission="issue-assign-user">
        <MenuItem onClick={onOpenAssignDialog}>Assign User</MenuItem>
      </Can>
      <Can permission="issue-assigned-users-list">
        <MenuItem onClick={onOpenAssignedUsersDialog}>Assigned Users</MenuItem>
      </Can>
      <Can permission="issue-delete">
        <MenuItem onClick={handleDelete} sx={{ color: 'error.main' }}>
          Delete
        </MenuItem>
      </Can>
    </Menu>
  );
};

export default IssueActionsMenu;